export default {
    items: [
        { title: 'Home', icon: 'mdi-home', color: 'red lighten-1', link: '/', permiso: '', dash: true, textclass: 'white--text headline'  },
        { title: 'Inventario', icon: 'mdi-cart-arrow-down', color: 'orange', link: 'inventario', permiso: '', dash: true, textclass: 'white--text headline' },
    ],
}